import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { ServerConfig } from './server-config.model';

@Injectable({
	providedIn: 'root'
})
export class ServerConfigService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) {
	}

	public getServerConfigs(): Observable<ServerConfig[]> {
		const url = `${this.appConfigService.getConfig().webApi}/api2/serverConfigs`;
		return this.http.get<ServerConfig[]>(url)
			.pipe(catchError(this.errorHandler.handleError<ServerConfig[]>(`get server config`)));
	}

	public updateServerConfig(serverConfig: ServerConfig): Observable<ServerConfig> {
		return this.http.put<ServerConfig>(`${ this.appConfigService.getConfig().webApi }/api2/serverConfigs/${ serverConfig.configId }`, { value: serverConfig.value })
			.pipe(catchError(this.errorHandler.handleError<ServerConfig>(`[PUT] Server Config failed for configId=${ serverConfig.configId }`)));
	}
}
